export default "__VITE_ASSET__C$HYtMtB__"